<template>
  <template v-if="appStore.guestlineActiveUrl">
    <Teleport to="body">
      <iframe-bar
        :src="appStore.guestlineActiveUrl"
        :is-open="isOpen"
        :header="t('book-room-cta-long')"
        @on-close="closeIframeBar"
        @on-close-animation-end="clearGuestlineActiveUrl"
      />
    </Teleport>
  </template>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import IframeBar from '../IframeBar/IframeBar.vue';
import { useAppStore } from '../../../stores/appStore';
import { useGuestlineListener } from '../../../composables/useGuestlineListener';
import { useJssStore } from '../../../stores/jssStore';

const { t } = useI18n();
const appStore = useAppStore();
const jssStore = useJssStore();

const isOpen = ref(false);

const guestlineUrl: string | null = jssStore.guestlineUrl || null;
if (guestlineUrl) useGuestlineListener(guestlineUrl);

const openIframeBar = () => {
  setTimeout(() => (isOpen.value = true), 0);
};

const closeIframeBar = () => {
  isOpen.value = false;
};

const clearGuestlineActiveUrl = () => {
  appStore.setGuestlineActiveUrl(null);
};

watch(
  () => appStore.guestlineActiveUrl,
  () => {
    if (appStore.guestlineActiveUrl) openIframeBar();
  }
);
</script>
